// 261010 Epic 2 / P6 (lượt 2) — chọn bản clip + ghi lý do (thuần, không antd). BE KHÔNG nhận `note` ở `PUT select-clip` (`_p6/dev-be-1.md` §5 mục 20):
// bấm select-clip như cũ, RỒI nếu có lý do và phiếu của bản đó ghi được ⇒ `POST /step-reviews/:id/decide { decision: 'ACCEPT', note }`.
// Lỗi ghi lý do (vd. 409 REVIEW_STALE) KHÔNG huỷ lựa chọn: phiếu chỉ hiện, không chặn (User 25/10).
import { stepReviewActionError, type StepReviewError } from './stepReviewPolicy';

export interface SelectFlowApi { select: (clipId: string) => Promise<unknown>; decide: (reviewId: string, note: string) => Promise<unknown> }
/** NONE = không có lý do · SAVED = đã ghi vào phiếu · NOT_STORABLE = có lý do nhưng bản này không có phiếu hợp lệ để ghi · FAILED = decide lỗi (lựa chọn vẫn giữ). */
export type ReasonOutcome = 'NONE' | 'SAVED' | 'NOT_STORABLE' | 'FAILED';
export interface SelectFlowResult { selected: boolean; selectError?: unknown; reason: ReasonOutcome; reasonError?: StepReviewError }

export async function selectWithReason(api: SelectFlowApi, o: { clipId: string; note: string | null; reviewId: string | null }): Promise<SelectFlowResult> {
  try { await api.select(o.clipId); }
  catch (e) { return { selected: false, selectError: e, reason: 'NONE' }; }
  if (!o.note) return { selected: true, reason: 'NONE' };
  if (!o.reviewId) return { selected: true, reason: 'NOT_STORABLE' };
  try { await api.decide(o.reviewId, o.note); }
  catch (e) { return { selected: true, reason: 'FAILED', reasonError: stepReviewActionError(e, 'Ghi lý do vào phiếu', 'CLIP_REVIEW') }; }
  return { selected: true, reason: 'SAVED' };
}

export function reasonOutcomeText(o: ReasonOutcome, err?: string): { tone: 'success' | 'info' | 'warning'; text: string } {
  if (o === 'SAVED') return { tone: 'success', text: 'Đã chọn bản clip và ghi lý do vào phiếu AI chấm' };
  if (o === 'NOT_STORABLE') return { tone: 'info', text: 'Đã chọn bản clip. Bản này chưa có phiếu hợp lệ nên lý do không được lưu lại.' };
  if (o === 'FAILED') return { tone: 'warning', text: `Đã chọn bản clip, nhưng chưa ghi được lý do${err ? ` — ${err}` : ''}` };
  return { tone: 'success', text: 'Đã chọn bản clip' };
}
